(function () {
  if (window.NSFeaturedDynamicCollection) {
    window.NSFeaturedDynamicCollection.initAll(document);
    return;
  }

  var requestCache = {};

  function locale() {
    return (
      window.Shopify && window.Shopify.locale
        ? window.Shopify.locale
        : document.documentElement.lang || 'default'
    ).toLowerCase();
  }

  function routeRoot() {
    var root = (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) || '/';

    return root.slice(-1) === '/' ? root : root + '/';
  }

  function recentCollections() {
    var key = 'ns_recent_product_collections_' + locale();

    try {
      var saved = JSON.parse(localStorage.getItem(key)) || [];
      if (!Array.isArray(saved)) return [];

      return saved.filter(function (handle, index) {
        return typeof handle === 'string' &&
          handle &&
          handle !== 'featured' &&
          saved.indexOf(handle) === index;
      });
    } catch (error) {
      return [];
    }
  }

  function collectionUrl(handle) {
    return routeRoot() + 'collections/' + encodeURIComponent(handle);
  }

  function fetchCollection(handle) {
    if (requestCache[handle]) return requestCache[handle];

    var requestUrl = collectionUrl(handle) +
      '?section_id=ns-collection-products-data';

    requestCache[handle] = fetch(requestUrl, {
      credentials: 'same-origin',
      headers: {
        Accept: 'text/html'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Request failed with status ' + response.status);
        }

        return response.text();
      })
      .then(function (html) {
        var parsedDocument = new DOMParser().parseFromString(
          html,
          'text/html'
        );

        var collectionData = parsedDocument.querySelector(
          '[data-ns-collection-data]'
        );

        if (!collectionData) {
          throw new Error('No collection data returned for ' + handle);
        }

        var productsContainer = collectionData.querySelector(
          '[data-ns-products]'
        );

        var cards = productsContainer
          ? Array.prototype.slice.call(productsContainer.children).filter(
              function (element) {
                return element.hasAttribute('data-product-item');
              }
            )
          : [];

        return {
          title: collectionData.getAttribute('data-title') || handle,
          url: collectionData.getAttribute('data-url') ||
            collectionUrl(handle),
          cards: cards.map(function (card) {
            return card.outerHTML;
          })
        };
      });

    return requestCache[handle];
  }

  function sectionEvent(sectionRoot, eventName, sectionId) {
    sectionRoot.dispatchEvent(new CustomEvent(eventName, {
      bubbles: true,
      detail: {
        sectionId: sectionId
      }
    }));
  }

  function updateButton(
    config,
    sectionRoot,
    collectionTitle,
    collectionUrl
  ) {
    var button = sectionRoot.querySelector(
      '.featured-collection__button'
    );

    if (!button) return;

    if (collectionUrl) {
      button.setAttribute('href', collectionUrl);
    }

    if (config.dataset.ctaIncludeTitle !== 'true') return;

    var prefix = (config.dataset.ctaPrefix || '').trim();
    var title = (collectionTitle || '').trim();
    var label = [prefix, title].filter(Boolean).join(' ');

    if (label) {
      button.textContent = label;
    }
  }

  function updateQuotePrices(config, sectionRoot) {
    var quoteLabel = (
      config.dataset.quoteLabel || 'Contact us for a quote'
    ).trim();

    sectionRoot
      .querySelectorAll('[data-ns-quote-price="true"]')
      .forEach(function (card) {
        var price = card.querySelector(
          '.productitem--price, ' +
          '.productitem__price, ' +
          '[data-product-price]'
        );

        if (!price) return;

        price.textContent = '';

        var label = document.createElement('span');
        label.className = 'ns-productitem--quote-price';
        label.textContent = quoteLabel;

        price.appendChild(label);
      });
  }

  function replaceProducts(config, collectionData) {
    var sectionRoot = config.closest(
      '[id^="shopify-section-"]'
    );

    if (!sectionRoot) return;

    var content = sectionRoot.querySelector(
      '[data-featured-collection] [data-content]'
    );

    if (!content) return;

    var productCount = parseInt(
      config.dataset.productCount || '5',
      10
    );

    var cards = collectionData.cards.slice(0, productCount);

    if (!cards.length) return;

    sectionEvent(
      sectionRoot,
      'shopify:section:unload',
      config.dataset.sectionId
    );

    Array.prototype.slice
      .call(content.children)
      .forEach(function (element) {
        if (element.hasAttribute('data-product-item')) {
          element.remove();
        }
      });

    var template = document.createElement('template');
    template.innerHTML = cards.join('');

    content.appendChild(
      template.content.cloneNode(true)
    );

    var requestedLayout =
      config.dataset.desktopLayout || 'grid';

    content.dataset.layout =
      requestedLayout === 'slideshow' && cards.length > 5
        ? 'slideshow'
        : 'grid';

    if (config.dataset.useCollectionTitle === 'true') {
      var title = sectionRoot.querySelector(
        '[data-ns-dynamic-title]'
      );

      if (title) {
        title.textContent = collectionData.title;
        title.hidden = false;
      }
    }

    updateButton(
      config,
      sectionRoot,
      collectionData.title,
      collectionData.url
    );

    sectionEvent(
      sectionRoot,
      'shopify:section:load',
      config.dataset.sectionId
    );

    updateQuotePrices(config, sectionRoot);
  }

  function init(config) {
    if (
      !config ||
      config.dataset.nsInitialized === 'true'
    ) {
      return;
    }

    config.dataset.nsInitialized = 'true';

    var sectionRoot = config.closest(
      '[id^="shopify-section-"]'
    );

    if (sectionRoot) {
      updateButton(
        config,
        sectionRoot,
        config.dataset.fallbackTitle || '',
        ''
      );
    }

    var position = parseInt(
      config.dataset.historyPosition || '1',
      10
    ) - 1;

    var handle = recentCollections()[position];

    if (!handle) return;

    fetchCollection(handle)
      .then(function (collectionData) {
        replaceProducts(config, collectionData);
      })
      .catch(function (error) {
        console.warn(
          'NS dynamic collection:',
          handle,
          error
        );
      });
  }

  function initAll(scope) {
    var searchRoot = scope || document;

    if (
      searchRoot.nodeType === 1 &&
      searchRoot.matches(
        '[data-ns-dynamic-featured-collection]'
      )
    ) {
      init(searchRoot);
    }

    searchRoot
      .querySelectorAll(
        '[data-ns-dynamic-featured-collection]'
      )
      .forEach(init);
  }

  window.NSFeaturedDynamicCollection = {
    initAll: initAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      function () {
        initAll(document);
      }
    );
  } else {
    initAll(document);
  }

  document.addEventListener(
    'shopify:section:load',
    function (event) {
      if (!event || !event.target) return;
      initAll(event.target);
    }
  );
})();